import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { addAttachmentsByWorkorderIdAsync, createWorkOrderAsync, getAllAttachmentsByWorkorderIdAsync, getAllJobCategoriesAsync, getAllObjectsAsync, getAllWorkOrderAsync, getContactPersonsByIdAsync, getWorkOrderByIdAsync, getWorkOrderNumberAsync, getWorkshopLocationAsync, updateWorkOrderAsync, deleteWorkOrderAttachmentAsync, saveWorkOrderNoteAsync, getAllWorkOrderStatusAsync, getAllActiveWorkOrderAsync, getAllProgressNotesByWorkOrderIdAsync, deleteProgressNotesByIdAsync, createProgressNotesByIdAsync, updateWorkorderToUrgentAsync, getOrdersByWorkOrderIdAsync, deleteWorkOrderByIdAsync, getAllWorkOrdersOnMoveAsync, generateDeliveryNotePdfAsync, generateOtherWerkbonPdfAsync, generateMotorReductorWerkbonPdfAsync, generatePompWerkbonPdfAsync, generateMotorWerkbonPdfAsync, generateTrommelmotorWerkbonPdfAsync, generateVentilatorWerkbonPdfAsync, generateStandardWerkbonPdfAsync, getAllEmployeesByLocationIdAsync, getAllWorkshopLocationByCurrentEmployeeAsync, generateTerplaatsWerkbonPdfAsync, generateSealWerkbonPdfAsync, getAllWorkOrdersDetailsAsync, getAllWorkOrdersByIdAsync, updateModulePermissionsStatusAsync } from './workorderThunk';
import { AppConsts } from '@application/common/constants/app-consts';
import { RoleCategory } from '@application/common/enums/role-category';
const workOrderRequest = {
    pageNumber: AppConsts.GRID_DEFAULT_PAGE_NUMBER,
    pageSize: AppConsts.GRID_DEFAULT_PAGE_SIZE,
};
const activeWorkOrderRequest = {
    pageNumber: AppConsts.GRID_DEFAULT_PAGE_NUMBER,
    pageSize: AppConsts.GRID_DEFAULT_PAGE_SIZE,
};
const workOrderDetailsRequest = {
    pageNumber: AppConsts.GRID_DEFAULT_PAGE_NUMBER,
    pageSize: AppConsts.GRID_DEFAULT_PAGE_SIZE,
};
const initialState = {
    status: APIStatus.IDLE,
    workOrderRequest: workOrderRequest,
    activeWorkOrderRequest: activeWorkOrderRequest,
    workOrderDetailsRequest: workOrderDetailsRequest,
    timeRemaining: parseInt(process.env.REACT_APP_INACTIVITY_TIME),
    isWarningVisible: false,
    moduleLocked: false
};
export const workorderSlice = createSlice({
    name: 'workorder',
    initialState,
    reducers: {
        // updateWorkOrder: (state, action: PayloadAction<WorkOrderDto>) => {
        //     state.workOrder = action.payload;
        // },
        startTimer: (state) => {
            state.isWarningVisible = false;
            state.timeRemaining = parseInt(process.env.REACT_APP_INACTIVITY_TIME);
        },
        decrementTimer: (state, action) => {
            const secondsToDecrement = action.payload || 1; // Fallback to 1 if not provided
            if (state.timeRemaining > 0) {
                state.timeRemaining -= secondsToDecrement;
            }
            if (state.timeRemaining <= parseInt(process.env.REACT_APP_TIME_TO_SHOW_WARNING_POPUP)) {
                state.isWarningVisible = true;
            }
            if (state.timeRemaining <= 0) {
                state.timeRemaining = 0;
                state.isWarningVisible = false;
                // Add logic to handle navigation or other behavior when time runs out
            }
        },
        // decrementTimer: (state) => {
        //     if (state.timeRemaining > 0) {
        //         state.timeRemaining -= 1;
        //     }
        //     if (state.timeRemaining <= parseInt(process.env.REACT_APP_TIME_TO_SHOW_WARNING_POPUP!)) {
        //         state.isWarningVisible = true;
        //     }
        //     if (state.timeRemaining === 0) {
        //         state.isWarningVisible = false;
        //         // Add any other logic here, like navigating the user away
        //     }
        // },
        resetTimer: (state) => {
            state.timeRemaining = parseInt(process.env.REACT_APP_INACTIVITY_TIME); //ModuleInactivityTimeConstants.inactivity_time;;
            state.isWarningVisible = false;
        },
        closeWarning: (state) => {
            state.isWarningVisible = false;
        },
        setModuleLock: (state) => {
            state.moduleLocked = true;
        },
        unsetModuleLock: (state) => {
            state.moduleLocked = false;
        },
        clearUpdateModulePermissionStatus: (state) => {
            state.updateModulePermissionStatus = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllJobCategoriesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllJobCategoriesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.workCategories = action.payload;
            state.workCategoryDropdown = action.payload.map((category) => {
                return {
                    label: `${category.name}`,
                    value: category.id
                };
            });
        })
            .addCase(getAllJobCategoriesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getWorkOrderNumberAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getWorkOrderNumberAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.workOrderNumber = action.payload.toString();
        })
            .addCase(getWorkOrderNumberAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getWorkshopLocationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getWorkshopLocationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.workShopLocation = action.payload;
            state.workShopLocationDropdown = action.payload.map((workshoplocation) => {
                return {
                    label: `${workshoplocation.location}`,
                    value: workshoplocation.id
                };
            });
            state.workShopLocationLabelDropdown = action.payload.map((workshoplocationlabel) => {
                return {
                    label: `${workshoplocationlabel.location}`,
                    value: workshoplocationlabel.location
                };
            });
        })
            .addCase(getWorkshopLocationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getWorkOrderByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getWorkOrderByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.unchangedWorkorder = action.payload;
            state.workOrder = action.payload;
        })
            .addCase(getWorkOrderByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllWorkOrdersByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllWorkOrdersByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.workOrderWithoutLocationCheck = action.payload;
        })
            .addCase(getAllWorkOrdersByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllObjectsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllObjectsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.object = action.payload;
            state.objectDropdown = action.payload.filter(object => object.category === 'Objectnaam').map((object) => {
                return {
                    label: `${object.name}`,
                    value: String(object.id)
                };
            });
            state.objectLabelDropdown = action.payload.filter(object => object.category === 'Objectnaam').map((object) => {
                return {
                    label: `${object.name}`,
                    value: `${object.name}`
                };
            });
        })
            .addCase(getAllObjectsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getContactPersonsByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getContactPersonsByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.contactPerson = action.payload;
            state.contactPersonDropdown = action.payload.map((contactperson) => {
                return {
                    label: `${contactperson.firstName ? contactperson.firstName : ''} ${contactperson.lastName ? contactperson.lastName : ''}`,
                    value: contactperson.id,
                    number: `${contactperson.phoneNumber ? contactperson.phoneNumber : ''}`,
                    WorkOrderid: contactperson.workOrderId,
                    email: contactperson.email
                };
            });
        })
            .addCase(getContactPersonsByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createWorkOrderAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createWorkOrderAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.workOrder = action.payload;
        })
            .addCase(createWorkOrderAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllWorkOrderAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllWorkOrderAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.workOrders = action.payload;
        })
            .addCase(getAllWorkOrderAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateWorkOrderAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateWorkOrderAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.updateWorkOrder = action.payload;
        })
            .addCase(updateWorkOrderAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllAttachmentsByWorkorderIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllAttachmentsByWorkorderIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.workOrderAttachments = action.payload;
        })
            .addCase(getAllAttachmentsByWorkorderIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(addAttachmentsByWorkorderIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(addAttachmentsByWorkorderIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.uploadAttachment = action.payload;
        })
            .addCase(addAttachmentsByWorkorderIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteWorkOrderAttachmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteWorkOrderAttachmentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.deleteAttachment = action.payload;
        })
            .addCase(deleteWorkOrderAttachmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(saveWorkOrderNoteAsync.pending, (state) => {
            state.status = APIStatus.FAILED;
            state.apiError = undefined;
        })
            .addCase(saveWorkOrderNoteAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(saveWorkOrderNoteAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
        });
        builder
            .addCase(getAllWorkOrderStatusAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllWorkOrderStatusAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.workOrderStatus = action.payload;
            state.workOrderStatusDropdown = action.payload.map((status) => {
                return {
                    label: `${status.name}`,
                    value: status.id,
                    number: `${status.description}`,
                };
            });
        })
            .addCase(getAllWorkOrderStatusAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllActiveWorkOrderAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllActiveWorkOrderAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.ActiveworkOrders = action.payload;
        })
            .addCase(getAllActiveWorkOrderAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllProgressNotesByWorkOrderIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllProgressNotesByWorkOrderIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.workOrderProgressNotes = action.payload;
        })
            .addCase(getAllProgressNotesByWorkOrderIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteProgressNotesByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteProgressNotesByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.deleteProgressNotes = action.payload;
        })
            .addCase(deleteProgressNotesByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createProgressNotesByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createProgressNotesByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.workOrderProgressNote = action.payload;
        })
            .addCase(createProgressNotesByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateWorkorderToUrgentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateWorkorderToUrgentAsync.fulfilled, (state) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(updateWorkorderToUrgentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getOrdersByWorkOrderIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getOrdersByWorkOrderIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.workorderOrders = action.payload;
        })
            .addCase(getOrdersByWorkOrderIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteWorkOrderByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteWorkOrderByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(deleteWorkOrderByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllWorkOrdersOnMoveAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllWorkOrdersOnMoveAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.workOrdersOnMove = action.payload;
        })
            .addCase(getAllWorkOrdersOnMoveAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generateDeliveryNotePdfAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generateDeliveryNotePdfAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generateDeliveryNotePdfAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generateOtherWerkbonPdfAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generateOtherWerkbonPdfAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generateOtherWerkbonPdfAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generateMotorReductorWerkbonPdfAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generateMotorReductorWerkbonPdfAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generateMotorReductorWerkbonPdfAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generatePompWerkbonPdfAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generatePompWerkbonPdfAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generatePompWerkbonPdfAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generateMotorWerkbonPdfAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generateMotorWerkbonPdfAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generateMotorWerkbonPdfAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generateTrommelmotorWerkbonPdfAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generateTrommelmotorWerkbonPdfAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generateTrommelmotorWerkbonPdfAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generateVentilatorWerkbonPdfAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generateVentilatorWerkbonPdfAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generateVentilatorWerkbonPdfAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generateStandardWerkbonPdfAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generateStandardWerkbonPdfAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generateStandardWerkbonPdfAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllEmployeesByLocationIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllEmployeesByLocationIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.employeeByLocation = action.payload;
            state.managerByLocationDropdown = action.payload.filter(x => x.categoryId === RoleCategory.Projectleider && x.isActive).map((employee) => {
                return {
                    label: `${employee.firstName} ${employee.lastName} `,
                    value: employee.id,
                    number: `${employee.identifier}`,
                };
            });
            state.technicianByLocationDropdown = action.payload.filter(x => x.categoryId === RoleCategory.Uitvoerende && x.isActive).map((employee) => {
                return {
                    label: `${employee.firstName} ${employee.lastName} `,
                    value: employee.id,
                    number: `${employee.identifier}`,
                };
            });
            state.employeeByLocationDropdown = action.payload.filter(x => x.id != null).map((employee) => {
                return {
                    label: `${employee.identifier} - ${employee.firstName} ${employee.lastName} `,
                    value: employee.id,
                    number: `${employee.identifier}`,
                };
            });
        })
            .addCase(getAllEmployeesByLocationIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllWorkshopLocationByCurrentEmployeeAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllWorkshopLocationByCurrentEmployeeAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.workShopLocation = action.payload;
            state.workShopLocationByCurrentEmployeeDropdown = action.payload.map((workshoplocation) => {
                return {
                    label: `${workshoplocation.location}`,
                    value: workshoplocation.id
                };
            });
            state.workShopLocationByCurrentEmployeeLabelDropdown = action.payload.map((workshoplocationlabel) => {
                return {
                    label: `${workshoplocationlabel.location}`,
                    value: workshoplocationlabel.location
                };
            });
        })
            .addCase(getAllWorkshopLocationByCurrentEmployeeAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generateTerplaatsWerkbonPdfAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generateTerplaatsWerkbonPdfAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generateTerplaatsWerkbonPdfAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generateSealWerkbonPdfAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generateSealWerkbonPdfAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generateSealWerkbonPdfAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllWorkOrdersDetailsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllWorkOrdersDetailsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.workOrdersDetails = action.payload;
        })
            .addCase(getAllWorkOrdersDetailsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateModulePermissionsStatusAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateModulePermissionsStatusAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.updateModulePermissionStatus = action.payload;
        })
            .addCase(updateModulePermissionsStatusAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = undefined;
        });
    }
});
export const { startTimer, decrementTimer, resetTimer, closeWarning, setModuleLock, unsetModuleLock, clearUpdateModulePermissionStatus } = workorderSlice.actions;
export default workorderSlice.reducer;
